<div class="margin-bottom-24" *ngIf="records.length > 0">
  <panel heading="Additional Records ({{side}} Side)" class="max-height">
    <div *ngFor="let record of records">
      <!-- here we need to identify which input type should we display    text or number    only observation will be presented as text -->
      <additional-record-yesno *ngIf="record.Type == 'YES/NO'" [recordId]="record.RecordId" [id]="record.Id" [inspectionId]="inspectionId" [side]="side"></additional-record-yesno>
      <!-- <additional-record-text *ngIf="record.Type == 'OB' " [recordId]="record.RecordId" [id]="record.Id" [inspectionId]="inspectionId" [side]="side"></additional-record-text> -->
      <additional-record-text *ngIf="record.Type == null " [recordId]="record.RecordId" [id]="record.Id" [inspectionId]="inspectionId" [side]="side"></additional-record-text>
      <additional-record-number *ngIf="(record.Type != 'OB' && record.Type != 'YES/NO' && record.Type != null)" [recordId]="record.RecordId" [id]="record.Id" [inspectionId]="inspectionId" [side]="side"></additional-record-number>
    
    </div>
  </panel>
</div>
